import { useTranslation } from "react-i18next";
import React, { ChangeEvent, FunctionComponent, KeyboardEvent, useState } from 'react';
import { Button, Col, Dropdown, Input, MenuProps, Modal, Progress, Row, Space, Typography, Upload, UploadProps, message } from 'antd';
import { DownOutlined, LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import FormInput from '../../../../../components/form-input/FormInput';
import './filter-table.scss';
import { BASE_URL_V2 } from '../../../../../config/api/configApiv2';
import { useAuthStore } from '../../../../../stores/stores';

type FilterTableProps = {
  handleOpen: () => void,
  searchValue: string,
  isRendering: boolean,
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void,
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void,
  handleSubmitSearch: () => void,
  handleOpenFilter: () => void,
  exportExcel: () => void,
  handleDownloadFile: () => void,
  importExcel: (file: any) => void,
}

const FilterTable: FunctionComponent<FilterTableProps> = ({
  handleOpen,
  searchValue,
  isRendering,
  handleChangeInput,
  handleSearch,
  handleSubmitSearch,
  handleOpenFilter,
  exportExcel,
  handleDownloadFile,
  importExcel,
}) => {
  const { t } = useTranslation();
  const [fileName, setFileName] = useState<string>("");
  const [progress, setProgress] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState<boolean>(true);
  const [file, setFile] = useState<any>();
  const accessToken = useAuthStore((state) => state.accessToken);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleImportExcel = () => {
    const formData = new FormData();
    formData.append('file', file);
    importExcel(formData);
    setIsModalOpen(false);
    setFileName("");
    setShowProgress(false);
    setIsUploading(true);
  }

  const handleOk = () => {
    Modal.confirm({
      title: t('Xác nhận tải dữ liệu', 'Xác nhận tải dữ liệu'),
      content: ``,
      onOk: () => handleImportExcel(),
      centered: true,
      okText: t('Xác nhận', 'Xác nhận'),
      cancelText: t('Huỷ bỏ', 'Huỷ bỏ'),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  };

  const handleCancel = () => {
    setFileName("");
    setIsUploading(true);
    setShowProgress(false);
    setIsModalOpen(false);
  };

  const items: MenuProps['items'] = [
    {
      label: t('Tạo mới', 'Tạo mới'),
      key: '1',
      onClick: handleOpen,
    },
    {
      label: t('Import dữ liệu', 'Import dữ liệu'),
      key: '2',
      onClick: showModal,
    },
    // {
    //   label: t("Thêm từ CSDL ngành", "Thêm từ CSDL ngành"),
    //   key: '3',
    // },
    {
      label: t('Tải file mẫu', 'Tải file mẫu'),
      key: '4',
      onClick: handleDownloadFile,
    },
  ];

  const menuProps = {
    items,
  };

  const props: UploadProps = {
    name: 'file',
    action: BASE_URL_V2 + `/mooc-course-block-quiz/upload-file`,
    headers: {
      Authorization: "Bearer " + accessToken,
    },
    beforeUpload: (file) => {
      if (!isCorrectFile(file)) {
        message.error(t(t("Bạn phải tải lên file excel !", "Bạn phải tải lên file excel !"), t("Bạn phải tải lên file excel !", "Bạn phải tải lên file excel !")));
        return Upload.LIST_IGNORE;
      }
    },
    onChange(info) {
      setProgress(0);
      setFileName(info.file.name);
      setShowProgress(true);
      setIsUploading(true);
      if (info.file.status === "uploading") {

      }
      if (info.file.status === "done") {
        setFile(info.file.originFileObj);
        setProgress(Math.round(100));
        setIsUploading(false);
      }
    },
  };

  const isCorrectFile = (file: any) => {
    const acceptFile = [
      // excel
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const isJpgOrPng = acceptFile.includes(file.type);
    // const isCorrectFile = file.size < MAX_FILE_UPLOAD_SIZE;
    if (isJpgOrPng) {
      return true;
    }
    return false;
  }

  const handleExportExcel = () => {
    Modal.confirm({
      title: t('Xác nhận kết xuất danh sách danh mục dùng chung', 'Xác nhận kết xuất danh sách danh mục dùng chung'),
      content: ``,
      onOk: () => exportExcel(),
      centered: true,
      okText: t('Xác nhận', 'Xác nhận'),
      cancelText: t('Huỷ bỏ', 'Huỷ bỏ'),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  }

  return (
    <>
      <div className="filter-table-portfolio">
        <div className="heading-item heading-filter">
          <Button className="filter-button" onClick={handleOpenFilter}>
            <Typography.Text> {t('Bộ lọc', 'Bộ lọc')} </Typography.Text>
            <DownOutlined />
          </Button>
        </div>
        <div className="heading-item heading-search">
          <FormInput placeholder={t("Nhập tên để tìm kiếm", "Nhập tên để tìm kiếm")} value={searchValue}
            onChange={handleChangeInput} onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />} />
        </div>
        <div className="heading-item heading-resigter">
          <Button className="btn btn-primary" onClick={handleExportExcel} disabled={isRendering}>
            <Typography.Text>{isRendering ? <LoadingOutlined /> : ''} {t('Kết xuất', 'Kết xuất')}</Typography.Text>
          </Button>
        </div>
        <div className="heading-item heading-resigter">
          <Dropdown placement='bottomRight' menu={menuProps}>
            <Button className='btn-add-new'>
              <Space> {t("Thêm danh mục", "Thêm danh mục")} <DownOutlined /> </Space>
            </Button>
          </Dropdown>
        </div>
      </div>
      <Modal className="portfolio-import-modal" title={t("Import danh mục", "Import danh mục")} open={isModalOpen} onOk={handleOk}
        onCancel={handleCancel} okText={t("Tải lên", "Tải lên")} cancelText={t("Hủy", "Hủy")} okButtonProps={{ disabled: isUploading }}>
        <Space.Compact>
          <Input className="name-label" placeholder={t("Chọn file từ máy tính", "Chọn file từ máy tính")} value={fileName} readOnly />
          <Upload showUploadList={false} {...props} maxCount={1}>
            <Button className="btn-primary">{t("Chọn tệp", "Chọn tệp")}</Button>
          </Upload>
        </Space.Compact>
        <div className={`upload-progress ${showProgress ? "progress-on" : "progress-off"}`}>
          <Typography.Text className="progress-label">
            {progress !== 100 ? t('Đang tải lên', 'Đang tải lên') : t('Đã tải lên', 'Đã tải lên')}({progress}%)
          </Typography.Text>
          <Progress percent={progress} showInfo={false} />
        </div>
      </Modal>
    </>
  );
};

export default FilterTable;
